export const TIER_INFO = {
  BASIC: {
    features: [
      "AppointmentManagement",
      "PetTreatmentHistory",
      "MedicalLetters",
      "UserAdministration",
      "EmployeeManagement",
      "ClientMessaging",
    ],
    missingFeatures: [
      "CustomizationOptionsForClinicBranding",
      "ManagmentOfCustomServices",
      "DocumentCategoriesManagement",
      "TemplatesForDoctorsLetters",
      "UserProfilePictures",
    ],
    longDescription: "BasicTierLongDescription",
  },
  EXTENDED: {
    features: [
      "AppointmentManagement",
      "PetTreatmentHistory",
      "MedicalLetters",
      "UserAdministration",
      "EmployeeManagement",
      "ClientMessaging",
      "CustomizationOptionsForClinicBranding",
      "ManagmentOfCustomServices",
      "DocumentCategoriesManagement",
      "TemplatesForDoctorsLetters",
      "UserProfilePictures",
    ],
    longDescription: "ExtendedTierLongDescription",
  },
};